import { render, staticRenderFns } from "./housingInformation.vue?vue&type=template&id=75b386b2&scoped=true&"
import script from "./housingInformation.vue?vue&type=script&lang=js&"
export * from "./housingInformation.vue?vue&type=script&lang=js&"
import style0 from "./housingInformation.vue?vue&type=style&index=0&id=75b386b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b386b2",
  null
  
)

export default component.exports